import {useEffect, useState} from 'react'

import {ALERT_EVENTS} from '../../../infra/utils/alerts'
import {Alert} from '../Alerts/Alert'
import {withTimer} from '../Alerts/withTimer'

const AlertWithTimer = withTimer(Alert)

export const AlertManager = () => {
  const [alerts, setAlerts] = useState([])

  const addAlert = alert => {
    setAlerts(prev => [...prev, alert])
  }

  const removeAlert = id => {
    setAlerts(prev => prev.filter(alert => alert.id !== id))
  }

  useEffect(() => {
    const handleShowAlert = event => {
      const {message, type, duration, id, heading, footer} = event.detail
      addAlert({message, type, duration, id, heading, footer})
    }

    const handleRemoveAlert = event => {
      const {id} = event.detail
      removeAlert(id)
    }

    window.addEventListener(ALERT_EVENTS.SHOW, handleShowAlert)
    window.addEventListener(ALERT_EVENTS.HIDE, handleRemoveAlert)

    return () => {
      window.removeEventListener(ALERT_EVENTS.SHOW, handleShowAlert)
      window.removeEventListener(ALERT_EVENTS.HIDE, handleRemoveAlert)
    }
  }, [])

  return (
    <div className="alert-container">
      {alerts.map(alert => (
        <AlertWithTimer
          key={alert.id}
          id={alert.id}
          type={alert.type}
          heading={alert.heading}
          message={alert.message}
          footer={alert.footer}
          duration={alert.duration}
        />
      ))}
    </div>
  )
}
